module.exports = __webpack_public_path__ + "img/icon-document-purple.589a9c6e.svg";